type Args = {
  step: number;
  precision: number;

  fromScale: { x: number; y: number };
  toScale: { x: number; y: number };
  easing: (progress: number) => number;
};

/**
 * Creates a single scale keyframe based on a given step.
 * Should be used when generating keyframes to animate width/height of an
 * element while preserving performance
 */
export function createScaleKeyframes({
  step,
  precision,
  easing,
  fromScale,
  toScale,
}: Args): [string, string] {
  const easedStep = easing(step / precision);

  const xScale = fromScale.x + (toScale.x - fromScale.x) * easedStep;
  const yScale = fromScale.y + (toScale.y - fromScale.y) * easedStep;
  const invXScale = 1 / xScale;
  const invYScale = 1 / yScale;

  return [`scale(${xScale}, ${yScale})`, `scale(${invXScale}, ${invYScale})`];
}
